import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

type ContactFormBlockState = {
    submitting: boolean;
};

const initialState: ContactFormBlockState = {
    submitting: false
};

export const ContactFormBlockStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setSubmitting(submitting: boolean) {
            patchState(store, { submitting });
        }
    }))
);
